module.exports = {
      id: "vikatan-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatan",
      toString: function () {
        return this.url;
      }
    }